// import React, { useEffect, useState, useRef } from "react";
// import ReactECharts from "echarts-for-react";
// import { APIConstants } from "../../../Common/APIConstants";
// import { adjustTimeByFiveHoursThirtyMinutes } from "../../../Utils/DateConverstion";
// import dayjs from "dayjs";
// import { getAdjustedDate } from "../CommonFunctions";
// import { useStoreUpdaterWithAPI } from "../../../Hooks/UseStoreUpdaterWithApi";
// import { Card } from "antd";

// const SMMLDonutConsumption = ({ theme, cardStyle }) => {
//   const { makeRequest } = useStoreUpdaterWithAPI();
//   const correctDate = new Date(getAdjustedDate());
//   const defaultToDate = dayjs(correctDate).hour(6).minute(30).second(0);
//   const defaultFromDate = dayjs(correctDate)
//     .subtract(30, "days")
//     .hour(6) 
//     .minute(30)
//     .second(0);

//   const [toDate, setToDate] = useState(defaultToDate);
//   const [fromDate, setFromDate] = useState(defaultFromDate);
//   const [loading, setLoading] = useState(true);
//   const [pieChartData, setPieChartData] = useState([]);

//   const pieChartRef = useRef(null);

//   const formatPieChartData = (responseData) => {
//     const pieData = [];

//     responseData.forEach((item) => {
//       const existingIndex = pieData.findIndex((p) => p.name === item.subGroupName);
//       if (existingIndex !== -1) {
//         pieData[existingIndex].value += item.subGroupConsumption;
//       } else {
//         pieData.push({
//           name: item.subGroupName,
//           value: item.subGroupConsumption,
//         });
//       }
//     });

//     return pieData;
//   };

//   const getResponse = async () => {
//     setLoading(true);
//     const inputData = {
//       FromDate: adjustTimeByFiveHoursThirtyMinutes(fromDate),
//       ToDate: adjustTimeByFiveHoursThirtyMinutes(toDate),
//     };

//     try {
//       const res = await makeRequest({
//         type: APIConstants.GET,
//         url: `${APIConstants.SMML_DONUT_CONSUMPTION}?FromDate=${inputData.FromDate}&ToDate=${inputData.ToDate}`,
//       });

//       console.log(res)
//       if (res && res.length > 0) {
//         const formattedPieData = formatPieChartData(res);
//         setPieChartData(formattedPieData);

//         // ✅ Dynamically update the pie chart
//         if (pieChartRef.current) {
//           pieChartRef.current.getEchartsInstance().setOption({
//             series: [{ data: formattedPieData }],
//           });
//         }
//       }
//     } catch (error) {
//       console.log(error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     getResponse();
//   }, []);

//   const pieOption = {
//     tooltip: { trigger: "item" },
//     legend: {
//       top: "5%",
//       left: "center",
//       textStyle: {
//           color: theme === "dark" ? "#ffffff" : "#000000", // ✅ Change legend color based on theme
//       },
//   },
//     series: [
//       {
//         name: "Consumption Breakdown",
//         type: "pie",
//         radius: ["40%", "70%"],
//         avoidLabelOverlap: false,
//         itemStyle: {
//           borderRadius: 10,
//           borderColor: "#fff",
//           borderWidth: 2,
//         },
//         label: {
//           show: true, // ✅ Show values inside the pie chart by default
//           position: "inside",
//           formatter: "{b}\n {c}", // 🔹 Format: Name: Value
//           fontSize: 10,
//           fontWeight: "bold",
//         },
//         emphasis: {
//           label: {
//             show: true,
//             fontSize: 14,
//             fontWeight: "bold",
//           },
//         },
//         labelLine: { show: false },
//         data: pieChartData, // 🔹 Dynamically set pie chart data
//       },
//     ],
//   };
//   return (
//     <div className="w-2/5">
//       <Card  style={cardStyle}
//        title={
//         <span className={`${theme==='dark'?'text-white':'text-black'}` }>Consumption Breakdown</span>
//       }>
//         <ReactECharts ref={pieChartRef} option={pieOption} />
//       </Card>
//     </div>
//   );
// };

// export default SMMLDonutConsumption;


import React, { useEffect, useState, useRef } from "react";
import ReactECharts from "echarts-for-react";
import { APIConstants } from "../../../Common/APIConstants";
import { adjustTimeByFiveHoursThirtyMinutes } from "../../../Utils/DateConverstion";
import dayjs from "dayjs";
import { getAdjustedDate } from "../CommonFunctions";
import { useStoreUpdaterWithAPI } from "../../../Hooks/UseStoreUpdaterWithApi";
import { Card } from "antd";

const SMMLDonutConsumption = ({ theme, cardStyle }) => {
  const { makeRequest } = useStoreUpdaterWithAPI();
  const correctDate = new Date(getAdjustedDate());
  const defaultFromDate =  dayjs(correctDate).subtract(1, "day").startOf("day"); 
  const defaultToDate =  dayjs(correctDate).startOf("day");

  const [toDate, setToDate] = useState(defaultToDate);
  const [fromDate, setFromDate] = useState(defaultFromDate);
  const [loading, setLoading] = useState(true);
  const [pieChartData, setPieChartData] = useState([]);
  const [total,setTotal] = useState(0)

  const pieChartRef = useRef(null);

  // const formatPieChartData = (responseData) => {
  //   const pieData = [];

  //   responseData.forEach((item) => {
  //     const existingIndex = pieData.findIndex((p) => p.name === item.subGroupName);
  //     if (existingIndex !== -1) {
  //       pieData[existingIndex].value += item.subGroupConsumption;
  //     } else {
  //       pieData.push({
  //         name: item.subGroupName,
  //         value: item.subGroupConsumption,
  //       });
  //     }
  //   });

  //   return pieData;
  // };

  // const getResponse = async () => {
  //   setLoading(true);
  //   const inputData = {
  //     FromDate: adjustTimeByFiveHoursThirtyMinutes(fromDate),
  //     ToDate: adjustTimeByFiveHoursThirtyMinutes(toDate),
  //   };

  //   try {
  //     const res = await makeRequest({
  //       type: APIConstants.GET,
  //       url: `${APIConstants.SMML_DONUT_CONSUMPTION}?FromDate=${inputData.FromDate}&ToDate=${inputData.ToDate}`,
  //     });

  //     if (res && res.length > 0) {
  //       const formattedPieData = formatPieChartData(res);
  //       setPieChartData(formattedPieData);

  //       if (pieChartRef.current) {
  //         pieChartRef.current.getEchartsInstance().setOption({
  //           series: [{ data: formattedPieData }],
  //         });
  //       }
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  const formatPieChartData = (responseData) => {
    let totalValue = 0;
    const pieData = [];
    console.log(responseData)
  
    responseData.forEach((item) => {
      if (item.subGroupName !== "Total") {
        pieData.push({ name: item.subGroupName=='IEXDAMAndRTM'?'IEXDAM&RTM':item.subGroupName, value: item.subGroupConsumption>0?item.subGroupConsumption:0 });
      }
      totalValue += item.subGroupConsumption;
    });
  
    return { pieData, totalValue };
  };

  const dummyData = [
    {
        "groupName": "Donut",
        "groupID": 6,
        "subGroupName": "TNPDCL",
        "subGroupConsumption": -32125,
        "subTarget": 0,
        "subGroupID": 10034,
        "fromDate": "2025-03-25T00:00:00",
        "toDate": "2025-03-26T00:00:00"
    },
    {
        "groupName": "Donut",
        "groupID": 6,
        "subGroupName": "DG",
        "subGroupConsumption": 51,
        "subTarget": 0,
        "subGroupID": 10035,
        "fromDate": "2025-03-25T00:00:00",
        "toDate": "2025-03-26T00:00:00"
    },
    {
        "groupName": "Donut",
        "groupID": 0,
        "subGroupName": "IEXGDAM",
        "subGroupConsumption": 0,
        "subTarget": 0,
        "subGroupID": 1,
        "fromDate": "2025-03-25T00:00:00",
        "toDate": "2025-03-26T00:00:00"
    },
    {
        "groupName": "Donut",
        "groupID": 0,
        "subGroupName": "IEXDAMAndRTM",
        "subGroupConsumption": 0,
        "subTarget": 0,
        "subGroupID": 2,
        "fromDate": "2025-03-25T00:00:00",
        "toDate": "2025-03-26T00:00:00"
    },
    {
        "groupName": "Donut",
        "groupID": 0,
        "subGroupName": "Wind",
        "subGroupConsumption": 0,
        "subTarget": 0,
        "subGroupID": 3,
        "fromDate": "2025-03-25T00:00:00",
        "toDate": "2025-03-26T00:00:00"
    },
    {
        "groupName": "Donut",
        "groupID": 0,
        "subGroupName": "Solar",
        "subGroupConsumption": 0,
        "subTarget": 0,
        "subGroupID": 4,
        "fromDate": "2025-03-25T00:00:00",
        "toDate": "2025-03-26T00:00:00"
    },
    {
        "groupName": "Donut",
        "groupID": 0,
        "subGroupName": "Total",
        "subGroupConsumption": -32074,
        "subTarget": 0,
        "subGroupID": 5,
        "fromDate": "2025-03-25T00:00:00",
        "toDate": "2025-03-26T00:00:00"
    }
]
  
  const getResponse = async () => {
    setLoading(true);
    const inputData = {
      FromDate: adjustTimeByFiveHoursThirtyMinutes(fromDate),
      ToDate: adjustTimeByFiveHoursThirtyMinutes(toDate),
    };
  
    try {
      const res = await makeRequest({
        type: APIConstants.GET,
        url: `${APIConstants.SMML_DONUT_CONSUMPTION}?FromDate=${inputData.FromDate}&ToDate=${inputData.ToDate}`,
      });
  
      if (res && res.length > 0) {
        console.log(dummyData)
        const { pieData, totalValue } = formatPieChartData(res);
        console.log(pieData)
        setPieChartData(pieData);
        setTotal(totalValue);
  
        // Update Pie Chart
        if (pieChartRef.current) {
          pieChartRef.current.getEchartsInstance().setOption({
            series: [
              { data: pieData }, // Main Pie Chart Data
              { data: [{ name: "Total", value: totalValue }] }, // Center Text
            ],
          });
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  
  const pieChartColors = [
    "#FF6384", "#36A2EB", "#FFCE56", "#4BC0C0", "#9966FF",
    "#FF9F40", "#E7E9ED", "#50C878", "#C71585", "#008080"
  ];
  
  const pieOption = {
    tooltip: { trigger: "item" },
    legend: {
      top: "5%",
      left: "center",
      textStyle: {
        color: theme === "dark" ? "#ffffff" : "#000000",
      },
    },
    series: [
      { 
        name: "Consumption Breakdown",
        type: "pie",
        radius: ["40%", "70%"],
        avoidLabelOverlap: false,
        itemStyle: {
          borderRadius: 10,
          borderColor: "#fff",
          borderWidth: 2,
        },
        label: {
          show: true,
          position: "inside",
          formatter: "{b}\n {c}",
          fontSize: 10,
          fontWeight: "bold",
        },
        emphasis: {
          label: {
            show: true,
            fontSize: 14,
            fontWeight: "bold",
          },
        },
        labelLine: { show: false },
        data: pieChartData.map((item, index) => ({
          ...item,
          itemStyle: { color: pieChartColors[index % pieChartColors.length] },
        })), // Assign colors dynamically
      },
      {
        type: "pie",
        radius: ["0%", "30%"], // Smaller circle for center text
        label: {
          show: true,
          position: "center",
          fontSize: 16,
          fontWeight: "bold",
          formatter: `Total: ${total}`, // Show total in the center
        },
        data: [{ name: "Total", value: total }], // Center Text
      },
    ],
  };
  
  
  useEffect(() => {
    getResponse(); 
  }, []);
  console.log(pieChartData)

  // Calculate the total consumption dynamically
  const totalConsumption = pieChartData.reduce((sum, item) => sum + item.value, 0);

  // const pieOption = {
  //   tooltip: { trigger: "item" },
  //   legend: {
  //     top: "5%",
  //     left: "center",
  //     textStyle: {
  //       color: theme === "dark" ? "#ffffff" : "#000000",
  //     },
  //   },
  //   series: [
  //     {
  //       name: "Consumption Breakdown",
  //       type: "pie",
  //       radius: ["40%", "70%"],
  //       avoidLabelOverlap: false,
  //       itemStyle: {
  //         borderRadius: 10,
  //         borderColor: "#fff",
  //         borderWidth: 2,
  //       },
  //       label: {
  //         show: true,
  //         position: "outside",
  //         formatter: "{b}: {c}",
  //         fontSize: 10,
  //         fontWeight: "bold",
  //       },
  //       emphasis: {
  //         label: {
  //           show: true,
  //           fontSize: 14,
  //           fontWeight: "bold",
  //         },
  //       },
  //       labelLine: { show: true },
  //       data: pieChartData,
  //     },
  //     {
  //       type: "pie",
  //       radius: ["0%", "30%"], // Smaller inner circle for total
  //       label: {
  //         show: true,
  //         position: "center",
  //         fontSize: 20,
  //         fontWeight: "bold",
  //         formatter: `Total: ${totalConsumption}`,
  //         color: theme === "dark" ? "#ffffff" : "#000000",
  //       },
  //       data: [{ value: totalConsumption, name: "" }], // Placeholder for total
  //     },
  //   ],
  // };

  return (
    <div className="w-2/5 text-left">
      <Card
        style={cardStyle}
        className={`${theme==='dark'?'bg-transparent':'text-black bg-[#ECFDF3]'}`}
        title={
          <span className={`${theme === "dark" ? "text-white" : "text-black"}`}>
            Consumption Breakdown
          </span>
        }
      >
        <ReactECharts ref={pieChartRef} option={pieOption} />
      </Card>
    </div>
  );
};

export default SMMLDonutConsumption;
